
// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES_OPERACIONAL = ['operacional_prana']
const ROLES_FINANCEIRO = ['financeiro', 'faturamento', 'triveni_governanca']

const breadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Títulos Liberados',
    to: 'TitulosLiberadosList'
  }
]

export default [
    {
        path: '/titulos-liberados',
        name: 'TitulosLiberadosList',
        component: () => import('@/views/LiberacaoTitulos/TituloListPage.vue'),
        meta: {
            roles: ROLES_OPERACIONAL,
            title: 'Títulos Liberados',
            breadcrumb: breadCrumb
        },
    },
    {
      path: '/titulos-liberados/financeiro',
      name: 'TitulosLiberadosFinanceiroList',
      component: () => import('@/views/LiberacaoTitulos/TituloFinanceiroListPage.vue'),
      meta: {
        roles: ROLES_FINANCEIRO,
        title: 'Previsão de Faturamento',
        breadcrumb: breadCrumb
      },
    }
];